import React from 'react'
import VehicleContainer from './VehicleContainer'

const Vehicle = props => <VehicleContainer {...props} data-test="component-tradeIn-vehicle" />

export default Vehicle
